var KEY_ESC = 27;
var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_ENTER = 13;
export { KEY_DOWN, KEY_ENTER, KEY_ESC, KEY_UP };